import axios from "@/axios";

export function ImportStatusGet() {
  return axios.get<Array<string>>("/products/import/nomenclature");
}
